import { IControlInput, IDeviceCategory, IDeviceItemGrouping } from './device';

// Instance is created for each device category.  All child
// sections and control-inputs directly reference the data
// returned from the server.
export class DeviceCategory implements IDeviceCategory {
    // Properties contained on the returned data corresponding
    // to a category.
    public categoryName: string;
    public elementType: string;
    public isEnabled: boolean;
    public isVisible: boolean;
    public order: number;

    // Properties added by the visitors to make binding to the
    // object model easier.
    public $ignoreChildren: boolean;
    public $categories: IDeviceCategory[];
    public $sections: IDeviceItemGrouping[];
    public $controlInputs: IControlInput[];

    constructor(state: any) {
        this.$ignoreChildren = false;
        this.$categories = [];
        this.$sections = [];
        this.$controlInputs = [];

        this.elementType = state.elementType;
        this.categoryName = state.displayText;
        this.isEnabled = state.isEnabled;
        this.isVisible = state.isVisible;
        this.order = state.order;
   }
}
